import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { IPreviewProratedEnterpriseLicenseCost, IPreviewProratedEnterpriseLicenseCostParams, IPreviewProratedEnterpriseLicenseCostData } from './interfaces';
import { showErrorMessage } from '../../notifications';

export const PREVIEW_PRORATED_ENTERPRISE_LICENSE_COST_THUNK_PREFIX = 'account/fetchPreviewProratedEnterpriseLicenseCost';
export const fetchPreviewProratedEnterpriseLicenseCost: AsyncThunk<IPreviewProratedEnterpriseLicenseCost | void, IPreviewProratedEnterpriseLicenseCostParams, ThunkAPI> =
  createAsyncThunk(
    PREVIEW_PRORATED_ENTERPRISE_LICENSE_COST_THUNK_PREFIX,
    async (data, thunk) => {
      if (!isFeatureEnabled(Features.TrialsOfTiers)) {
        thunk.dispatch({
          type: 'DO_NOTHING'
        });
        return;
      }
      try {
        const response = await basicApiAsyncThunkCreator<IPreviewProratedEnterpriseLicenseCost | void, IPreviewProratedEnterpriseLicenseCostData>({
          endpoint: `accounts/${data.accountId}/preview-prorated-enterprise-license-cost`,
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Post,
          contentType: 'application/json'
        })({
          numberOfSeats: data.numberOfSeats
        }, thunk);
        return response;
      } catch (err) {
        const errorMessage = typeof err === 'string' ? err : 'An error occurred on get preview prorated license cost';
        thunk.dispatch(showErrorMessage(errorMessage));
        return thunk.rejectWithValue(err);
      }
    }
  );
